/// REDUX ///
import { Dispatch } from "redux";
/// ACTIONS ///
import { Action } from "api/action_types/sketch";
/// ACTION TYPES ///
import { ActionType } from "api/action_types/sketch";
/// TYPES ///
import { CutShape } from "api/types/sketch";

export const updateLocalCutShape = (cut_shape: CutShape) => {
    return (dispatch: Dispatch<Action>) => {
        dispatch({
            type: ActionType.UPDATE_LOCAL_CUT_SHAPE,
            payload: cut_shape
        });
    }
}
